import { gql } from "graphql-request";

/**
 * Queries related to hotel search and room configuration.
 * Includes configuration details for booking forms and available hotel/city data.
 */

// Fetches labels and configuration data for room search and booking forms
export const SEARCH_AVAILABLE_ROOM_CONFIGURATIONS = gql`
  query configurationSearchForm(
    $locale: I18NLocaleCode
    $filters: SharedDatasourcesReusableReservationTextDatasourceFiltersInput
  ) {
    sharedDatasourcesReusableReservationTextDatasources(
      locale: $locale
      filters: $filters
    ) {
      item_name
      documentId
      configurations {
        checkin_label
        checkout_label
        promo_code_label
        promo_code_placeholder
      }
      rooms_configurations {
        adult_label
        children_label
        add_room_button_text
        maximum_adults
        maximum_child_age
        maximum_children
        maximum_rooms
        single_room_label
        default_adult_count
      }
      booking {
        booking_button_text
      }
      ages_configurations {
        ages_label
        age_placeholder
        single_child_label
      }
      tripla_section {
        tripla_add_room_label
        tripla_age_label
        tripla_apply_label
        tripla_bed_label
        tripla_child_label
        tripla_room_adults_label
        tripla_room_children_label
        tripla_room_name_label
        tripla_tier_info
        tripla_with_bed_label
        tripla_without_bed_label
        tripla_age_placeholder
        tripla_invalid_age_error
      }
    }
  }
`;

// Fetches all hotels and their external booking codes grouped by city/area
export const SEARCH_HOTELS_AND_CITIES_VALUE = gql`
  query SearchHotelsAndCitiesValue(
    $locale: I18NLocaleCode
    $status: PublicationStatus
  ) {
    japanAreas(pagination: { limit: -1 }, locale: $locale, status: $status) {
      item_name
      documentId
      hotels {
        item_name
        documentId
        external_ids {
          tripla_booking_code
          tripla_backend_code
        }
      }
    }
  }
`;
